import axios from 'axios'
import URL from '../../utils/urls'
import { CompleteRegistrationInvite } from './adf-screener-types'


export async function triggerCompleteRegistrationInvite(formData: CompleteRegistrationInvite) {
    const response = await axios.post(
        URL.bff.triggerCompleteRegistrationInvite,
        {
            company_info: {
                applicant_type: "Company",
                dba_name: formData.companyName,
                isNewCompany: (formData.isNextCompany || formData.isNewCompany) ?? false,
                lendx_company_id: formData.companyId
            },
            user_info: {
                name: {
                    given_name: formData.firstName,
                    last_name: formData.lastName,
                    preferred_name: formData.firstName
                },
                contact_information: {
                    email: formData.email,
                    phone_number: {
                        country_code: "+1",
                        primary: true,
                        number: formData.mobileNumber,
                        type: "MOBILE"
                    }
                }
            },
            pre_registration_user_info : {
                pre_registration_id: formData.preRegistrationId
            }
        }
    );
    return response.data
}